import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainNavigationService {
  private _mainNavState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public setMainNavState(isOpen: boolean): void {
    this._mainNavState$.next(isOpen);
  }

  public getMainNavState(): Observable<boolean> {
    return this._mainNavState$.asObservable();
  }
}
